<template>
  <app-sidebar v-if="sidebarVisible" />
  <app-header :class="{ 'md:left-250': sidebarVisible }" />
  <main
    class="absolute inset-0 top-50 flex flex-col overflow-auto bg-gray-100"
    :class="{ 'md:left-250': sidebarVisible }"
  >
    <router-view />
  </main>
  <AppToaster />
</template>

<script setup lang="ts">
import { provide, type Ref } from 'vue';
import AppToaster from '@/components/feedback/AppToaster.vue';
import { useLS } from '@/scripts/utils';
import AppHeader from './Header.vue';
import AppSidebar from './Sidebar.vue';
import '@/styles/main.css';
/// Setup
/**
 * Persisted layout flag — toggled by the header hamburger and the mobile close button. Provided to
 * Header + Sidebar via `inject('sidebarVisible')` to avoid a shared module file for one ref.
 */
const sidebarVisible = useLS<boolean>('menu_SidebarVisible', true);
provide<Ref<boolean>>('sidebarVisible', sidebarVisible);
</script>
